import { useTranslation } from "react-i18next";
import { useState } from "react";

import { LectureStatisticsPage } from "./LecturesStatisticsPage";
import { LecturesPage } from "./LecturesPage";
import { LectureAssignmentsPage } from "./Assignment/LectureAssignmentPage";
import { Redirect, Route, Switch } from "react-router-dom";
import { AssignmentQuestionsPage } from "./Assignment";

export const LecturesLayoutPage = (props: any) => {
  //#region hooks
  const { t } = useTranslation();
  const { match } = props;
  const { path, url } = match;
  //#endregion

  //#region internal state
  const [page, setPage] = useState<number>(1);

  //#endregion

  document.title = `${t("documentTitle", { pageName: "lectures" })}`;

  //#endregion

  return (
    <Switch>
      {/* Default redirect */}
      <Route exact path={path}>
        <Redirect to={`${url}/statistics`} />
      </Route>

      {/* Statistics */}
      <Route
        exact
        path={`${path}/statistics`}
        component={LectureStatisticsPage}
      />

      {/* Assignment Questions (MOST specific) */}
      <Route
        exact
        path={`${path}/:lessonId/:lectureId/:assignmentId/questions`}
        component={AssignmentQuestionsPage}
      />

      {/* Lecture Assignments */}
      <Route
        exact
        path={`${path}/:lessonId/:lectureId/assignments`}
        component={LectureAssignmentsPage}
      />

      {/* Lectures list by lesson */}
      <Route exact path={`${path}/:lessonId`} component={LecturesPage} />
    </Switch>
  );
};
